module.exports = __webpack_public_path__ + "static/img/parents-question.92e9dbb8.png";